import { render } from "./retail_hotel_index.vue?vue&type=template&id=5152ac8c"
import script from "./retail_hotel_index.vue?vue&type=script&lang=js"
export * from "./retail_hotel_index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__